import { render } from "./StatsSection.vue?vue&type=template&id=13d0c5fa&scoped=true"
import script from "./StatsSection.vue?vue&type=script&lang=js"
export * from "./StatsSection.vue?vue&type=script&lang=js"

import "./StatsSection.vue?vue&type=style&index=0&id=13d0c5fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d0c5fa"]])

export default __exports__